<template>
    <div class="pageContent-page p-20">
        <h1>{{selectedPage}}</h1>
        <p>{{ pages[selectedPage].title }}</p>
        <InpComponent
            :label="'type'"
            type="options"
            :options="[
                {text: 'Terms', value: 'terms'}, 
                {text: 'Privacy Policy', value: 'privacy'},
                {text: 'Terms of Use', value: 'terms-of-use'},
                {text: 'Agreement', value: 'agreement'}
            ]"
            @inputChange="selectedPage = $event[1]; loadPage()"
        />
        <CommentSection
            v-if="loaded"
            class="comment-section"
            :commentSection="pageContent.structure"
            @changeinput="quillContent" 
        >

        </CommentSection>
        <div>
            <button class="save" @click="save()">Save</button>
        </div>
    </div>
</template>

<script setup>
    import { ref, onMounted } from 'vue';
    import BO_API from '../api/bo_api.js'
    import API from '../api/index.js'
    import InpComponent from '@/components/InpComponent.vue';

    import { useStore } from 'vuex';
    import CommentSection from '@/views/CommentSection.vue';



    const pages = ref({
        'terms': { title: 'Terms and Conditions', apiData: null},
        'privacy': { title: 'Privacy Policy', apiData: null},
        'terms-of-use': { title: 'Terms of Use', apiData: null},
        'agreement': { title: 'Agreement', apiData: null},
    })

    const selectedPage = ref('terms');

    const store = useStore();
    const pageContent = ref([]);
    const loaded = ref(false);

    async function loadPage(){
        loaded.value = false;
        const responseData = await API.getPageContent(selectedPage.value, true);
        const data = responseData.pages[0];
        pageContent.value = data;
        if (pageContent.value.structure) {
            pageContent.value.structure = JSON.parse(pageContent.value.structure);
        }
        loaded.value = true;
    }

    onMounted( async () => {
        await loadPage();
    });


    function quillContent(event) {
        pageContent.value.structure = event.structure;
        pageContent.value.content = event.text;
    }
    async function save(){
        const resp = await BO_API.savePageContent(pageContent.value, selectedPage.value);
        if (resp.data && resp.data.status == 'success') {
            store.dispatch('addNotification', {text: 'pageContent changes successfully', type: 'success'})
        } else {
            store.dispatch('addNotification', {text: 'Error during pageContent change', type: 'error'})
        }
    }

</script>


<style lang="scss" scoped>
    .pageContent-page {
        min-height: 80vh;
    }
    .comment-section {
        height: 100%;


        &:deep(.editor-section) {
            height: 70vh;
        }
    }
    .save {
        margin-top: 20px;
        width: 100px;
        margin-left: auto;
    }
</style>